<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="商品名称" prop="goodsName">
        <el-input v-model="queryParams.goodsName" placeholder="请输入商品名称" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品编号" prop="goodsSn">
        <el-input v-model="queryParams.goodsSn" placeholder="请输入商品编号" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="状态" prop="publishStatus">
        <el-select-dict dictType="PUBLISH_STATUS" clearable placeholder="请选择状态" v-model="queryParams.publishStatus"
          @dictChange="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermission="['product:goods:create:update:read']" type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
        <el-button v-hasPermission="['product:goods:create:update:read']" type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
          @click="handleUpdate">编辑</el-button>
        <el-button v-hasPermission="['product:goods:delete']" type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
          @click="handleBatchDelete">删除</el-button>

        <el-tag type="warning" style="margin-left: 12px;">商品下架后，入库将无法查找到下架的商品！</el-tag>
      </div>
      <div class="table-box">
        <auto-height-table ref="brandTable" :class="{ 'empty': list.length === 0 }" empty-text=" " v-loading="loading"
          :data="list" row-key="goodsId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
          <el-table-column label="商品信息" prop="goodsName" align="left" min-width="300px">
            <template slot-scope="scope">
              <div class="goods-info flex-c-s">
                <div class="goods-info-left">
                  <img @click.stop="mixinHandlePreview(scope.row.goodsImgs && scope.row.goodsImgs.split(','))"
                    :src="mixinGetImg(scope.row.goodsImgs && scope.row.goodsImgs.split(',')[0])" width="40px" height="40px"
                    alt="商品图片">
                </div>
                <div class="goods-info-right flex-c-c flex-col">
                  <div class="top">
                    <span class="label">名称：</span>
                    <span class="value">{{ scope.row.goodsName }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">编号：</span>
                    <span class="value">{{ scope.row.goodsSn }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品品牌" prop="goodsSn" align="center" min-width="120px">
            <template slot-scope="scope">
              <div class="flex-c-s flex-col" v-if="scope.row.brandId">
                <img @click.stop="mixinHandlePreview(scope.row?.brandLogoSrc)" :src="mixinGetImg(scope.row?.brandLogoSrc)" width="40px"
                  height="40px" alt="商品logo" />
                <span class="goods-brand-name">{{ scope.row?.brandName }}</span>
              </div>
              <div class="" v-else>无</div>
            </template>
          </el-table-column>
          <el-table-column label="商品标签" prop="goodsName" align="center" min-width="256px" show-overflow-tooltip>
            <template slot-scope="scope">
              <template v-if="scope.row.tagArr.length > 0">
                <el-tag v-for="(item, index) in scope.row.tagArr" :key="index" :type="getType(index)"
                  :style="{ 'margin': '0 5px' }">{{ item }}
                </el-tag>
              </template>
              <template v-else>
                --
              </template>
            </template>
          </el-table-column>
          <el-table-column-dict dictType="PUBLISH_STATUS" dictTypeNode="tag" label="商品状态" align="center" prop="publishStatus"
            min-width="100px"></el-table-column-dict>
          <el-table-column label="操作人" prop="creator.userName" show-overflow-tooltip align="center" min-width="168px">
            <template slot-scope="scope">
              <div class="operater-box flex-c-c">
                <div class="operater-content-box">
                  <div class="top">
                    <span class="label">创建人：</span>
                    <span class="value">{{ scope.row.creator?.userName || "--" }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">更新人：</span>
                    <span class="value">{{ scope.row.updater?.userName || "--" }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              <div class="operater-box flex-c-c">
                <div class="operater-content-box">
                  <div class="top">
                    <span class="label">创建时间：</span>
                    <span class="value">{{ scope.row.createTime | formatDate("datetime", "--") }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">更新时间：</span>
                    <span class="value">{{ scope.row.updateTime | formatDate("datetime", "--") }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column v-if="
              mixinHasPermi([
                'product:goods:create:update:read',
                'product:goods:status',
                'product:goods:delete',
                'product:goods:tag',
              ])
            "  label="操作" align="center" :width="operateWidth + 'px'" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">

              <el-button v-hasPermission="['product:goods:status']" size="mini"
                :type="scope.row.publishStatus === '1' ? 'warning' : 'success'"
                @click.native.stop="handleStatusChange(scope.row)">{{ scope.row.publishStatus === "1" ? "下架" : "上架"
                }}</el-button>
              <el-tooltip popper-class="qrcode-box" placement="top" effect="light" v-hasPermission="['product:goods:create:update:read']">
                <div slot="content">
                  <div class="qrcode">
                    <img class="qr-code" :src="scope.row.qrcode" alt="商品二维码">
                  </div>
                  <p class="tips">手机扫一扫预览</p>
                </div>
                <el-button size="mini" type="primary" icon="el-icon-view" @click.native.stop="handleUpdate(scope.row)">查看</el-button>
              </el-tooltip>

              <el-button size="mini" type="danger" icon="el-icon-delete" v-hasPermission="['product:goods:delete']" :disabled="scope.row.beUsedInInventoryRecord"
                @click.native.stop="handleDelete(scope.row)">删除</el-button>
              <el-button size="mini" type="primary" plain v-hasPermission="['product:goods:tag']" v-if="permissionLength <= 3" 
                @click.native.stop="handleTag(scope.row)">分配标签</el-button>
              <el-dropdown v-if="
                  mixinHasPermi(['product:goods:tag']) &&
                  permissionLength > 3
                " @command="(command) => handleCommand(command, scope.row)">
                <span class="el-dropdown-link more" @click.stop>
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-hasPermission="['product:goods:tag']" command="handleTag">分配标签</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>

    <select-tag v-if="mixinHasPermi(['product:goods:tag'])" ref="goodsTag" :title="selectTagTitle" width="888px" :visible.sync="showSelectTag"
      :goodsId="selectGoodsTagId" @close="showSelectTag = false" @success="handleSelectTagSuccess"
      :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false"></select-tag>
  </div>
</template>

<script>
import { goodsApi } from "@/api"
import selectTag from "./components/select-tag.vue"
import QRCode from "qrcode"
export default {
  name: "productGoodsManage",
  components: {
    selectTag
  },
  data() {
    return {
      selectTagTitle: "", // 分配标签标题
      showSelectTag: false, // 是否显示分配角色
      selectGoodsTagId: "",
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        goodsName: "", // 商品名称
        goodsSn: "", // 商品编号
        publishStatus: "", // 商品状态
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      selection: [], //选中的项
      loading: false,
      total: 0,

      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      open: false,
      // 表单参数
      baseForm: {
        brandName: "", // 商品名称
        brandLogoSrc: "", // 商品logo链接
        remark: "" // 备注
      }

    }
  },
  computed: {
    // 三个按钮权限中 有多少个按钮权限
    permissionLength() {
      const permissionList = this.$store.getters.permissionList
      const list = [
        "product:goods:create:update:read",
        "product:goods:status",
        "product:goods:delete",
        "product:goods:tag"
      ]
      let num = 0
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (permissionList.includes(item)) {
          num++
        }
      }
      return num
    },
    // 计算操作项目表格宽度
    operateWidth() {
      if (this.permissionLength === 1) {
        return 168
      }
      if (this.permissionLength === 2) {
        return 208
      }
      if (this.permissionLength === 3) {
        return 288
      } 
      if (this.permissionLength === 4) {
        return 308
      } 
      return 288
    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          brandName: "", // 商品名称
          brandLogoSrc: "", // 商品logo链接
          remark: "" // 备注
        }
        this.$refs.brandDialog && this.$refs.brandDialog.resetForm()
      }
    },
    // 展示分配
    showSelectTag(val) {
      if (!val) {
        this.selectGoodsTagId = ""
        this.$refs.goodsTag.clearSelection()
        this.selectTagTitle = ""
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    // 生成二维码
    async getQrCode(row) {
      const qrCodeText = process.env.VUE_APP_WMS_H5 + "/#/goods-detail/" + row.goodsId 
      const qrCodeBase64 = await QRCode.toDataURL(qrCodeText)
      return qrCodeBase64
    },
    // 获取类型
    getType(index) {
      const arr = ["primary", "success", "info", "warning", "danger"]
      return arr[index]
    },
    // 分配tag
    handleTag(row) {
      this.selectTagTitle = `分配标签（${row.goodsName}）`
      this.selectGoodsTagId = row.goodsId
      this.showSelectTag = true
    },
    // 更多操作
    handleCommand(command, row) {
      if (command === "handleTag") {
        this.handleTag(row)
      }
    },
    // 分配标签成功
    handleSelectTagSuccess() {
      this.showSelectTag = false
      this.getList()
    },
    //点击行
    clickRow(row) {
      this.$refs.brandTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()
            
      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.goodsId)
        str += item.goodsName
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }

      this.$modal
        .confirm('删除后将无法找回！是否确认删除商品名称为"【' + str + '】"的数据项？')
        .then(function() {
          return goodsApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除商品成功")
        })
        .catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.brandTable.clearSelection()
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      goodsApi
        .getList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then(async(response) => {
          const list = response.rows
          for (let i = 0; i < list.length; i++) {
            const qrCodeBase64 = await this.getQrCode(list[i])
            list[i].qrcode = qrCodeBase64
          }
          this.list = list
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.$router.push({ name: "productPublishGoods", query: { type: "add" } })
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      let type = "look"
      if (!row.goodsId) {
        type = "edit"
      }
      const id = row.goodsId || (this.selection[0] && this.selection[0].goodsId)
      this.$router.push({ name: "productPublishGoods", query: { goodsId: id, type } })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()
      
      const id = row.goodsId
      this.$modal
        .confirm('删除后将无法找回！是否确认删除商品名称为"' + row.goodsName + '"的数据项？')
        .then(function() {
          return goodsApi.deleteItem({ id })
        })
        .then(() => {
          this.handleQuery()
          // 判断删除的项是否被勾选了
          const flag = this.selection.find((item) => item.brandId === id)
          flag && this.$refs.brandTable.toggleRowSelection(row, false)
          this.$modal.msgSuccess("删除成功")
        })
    },

    // 状态改变事件
    handleStatusChange(row) {
      goodsApi
        .changeStatus({
          goodsId: row.goodsId,
          publishStatus: row.publishStatus === "1" ? "0" : "1"
        })
        .then((data) => {
          this.$modal.msgSuccess("改变状态成功")
          this.getList()
        })
    }
  }
}
</script>
<style lang="scss">
.qrcode-box {
  border-color: #a7a7a7 !important;
  .popper__arrow {
    border-top-color: #a7a7a7 !important;
  }
  .qrcode {
    width: 124px;
    height: 124px;
    margin: 0 auto;
    .qr-code {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
    & + .tips {
      text-align: center;
      line-height: 24px;
      font-size: 14px;
    }
  }
}
</style>
<style lang="scss" scoped>
.xiaobu-container {
  .goods-brand-name {
    margin-top: 8px;
  }
}
</style>